import { Helmet } from "react-helmet-async";
import { useEffect } from "react";

const SITE = "https://vaidgram.in";
const DEFAULT_IMG = `${SITE}/hero.png`;

/**
 * Per-page SEO tags. Pass a page-specific title/description and this fills in
 * OG + Twitter + canonical automatically. Keep the description under ~160 chars.
 */
export default function Seo({
  title,
  description,
  path = "/",
  image = DEFAULT_IMG,
  type = "website",
  jsonLd,
  keywords,
  noindex = false,
}) {
  useEffect(() => { document.querySelectorAll("[data-static]").forEach((el) => el.remove()); }, []);
  const url = `${SITE}${path.startsWith("/") ? path : `/${path}`}`;
  const fullTitle = title
    ? `${title} · VaidGram`
    : "VaidGram — India's private network for BAMS & Ayurveda scholars";
  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />
      <meta name="robots" content={noindex ? "noindex" : "index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1"} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="VaidGram" />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
